import React from 'react';
import { useStaticQuery, graphql } from 'gatsby'
import Slider from 'react-slick';

import { FontAwesomeIcon } from '../../libs/fonts';

const Testimonials = ({ autoplay, autoplaySpeed, showDots }) => {
  const testimonialsQuery = useStaticQuery(graphql`
    query {
      allBuilderModels {
        testimonials (
          options: {
            cachebust: true
          }
        ) {
          id
          content
        }
      }
    }
  `);

  const list = testimonialsQuery?.allBuilderModels?.testimonials;

  if (!list?.length) {
    return null;
  }

  let testimonialsList = [];

  testimonialsList = list.map(({ id, content }) => {
    return {
      id,
      ...content?.data,
    };
  });

  return (
    <div className='rs-testimonial style2 bg23 pt-100 md-pt-80 mb-120'>
      <div className='fade-commcon-orange-bg testi-main'>
        <div className='fa-quote-img'>
          <FontAwesomeIcon
            size='8x'
            icon='fa-solid fa-quote-right'
            color='#EB3F0F'
          />
        </div>
        <div style={{ width: '90%' }}>
          <Slider
            arrows={false}
            autoplay={autoplay ?? true}
            autoplaySpeed={autoplaySpeed ? autoplaySpeed * 1000 : 5000}
            dots={showDots ?? true}
            infinite={true}
            slidesToScroll={1}
            slidesToShow={1}
            speed={500}
            swipeToSlide={true}
          >
            {testimonialsList.map(({ id, name, quote }) => (
              <div key={id} className='testi-item'>
                <div
                  className='desc'
                  dangerouslySetInnerHTML={{ __html: quote }}
                />
                <div className='testi-information'>
                  <div className='testi-name'>{name}</div>
                </div>
              </div>
            ))}
          </Slider>
        </div>

      </div>
    </div>
  );
};

export default Testimonials;
